export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'icon-speedometer'
        },
        {
            name: 'Ship',
            url: '/orders',
            icon: 'fa fa-truck',
            children: [
                {
                    name: 'Ready To Ship',
                    url: '/orders/ready-to-ship',
                    icon: 'icon-puzzle'
                }
            ]
        },
        {
            name: 'Address Book',
            url: '/address-book',
            icon: 'icon-user'
        },
        {
            name: 'Integrations',
            url: '/integrations',
            icon: 'icon-settings',
            children: [
                {
                    name: 'Existing Integrations',
                    url: '/integrations',
                    icon: 'icon-puzzle'
                },
                {
                    name: 'New Integrations',
                    url: '/integrations',
                    icon: 'icon-plus'
                }
            ]
        },
        {
            name: 'My Account',
            url: '/my-account',
            icon: 'icon-user'
        },
        {
            name: 'Help',
            url: '/help',
            icon: 'icon-user',
            children: [
                {
                    name: 'Tutorials',
                    url: '/help/tutorials',
                    icon: 'icon-puzzle'
                },
                {
                    name: 'Contact Support',
                    url: '/help/contact',
                    icon: 'icon-puzzle'
                },
                {
                    name: 'Postal Connect',
                    url: '/postal',
                    icon: 'icon-speedometer'
                }
            ]
        },
        {
            name: 'Postal Connect',
            url: '/postal',
            icon: 'icon-speedometer'
        }
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/js/_nav.js